import {Map} from 'immutable';
import SortableTable from './SortableTable.react';

export default Map({
  renderer: SortableTable,
  type: 'sortable-table',
  label: 'Sortable Table'
});
